import { themeQuartz } from 'ag-grid-enterprise'

export const darkAgGridTheme = themeQuartz.withParams({
  accentColor: '#96D9F6',
  backgroundColor: '#31373B',
  borderColor: '#FFFFFF1F',
  browserColorScheme: 'dark',
  chromeBackgroundColor: {
    ref: 'foregroundColor',
    mix: 0.07,
    onto: 'backgroundColor',
  },
  columnBorder: false,
  fontFamily: {
    googleFont: 'figtree',
  },
  foregroundColor: '#FFFFFF',
  headerBackgroundColor: '#FFFFFF0F',
  headerFontSize: 14,
  headerRowBorder: true,
  oddRowBackgroundColor: '#31373B',
})

export const lightAgGridTheme = themeQuartz.withParams({
  accentColor: '#41B2E2',
  browserColorScheme: 'light',
  fontFamily: {
    googleFont: 'figtree',
  },
  headerBackgroundColor: '#0000000A',
  headerFontSize: 14,
})
